module.exports = __webpack_public_path__ + "img/image02.3f72bde4.jpg";